// extracted by mini-css-extract-plugin
export default {"blocks-container":"styles_blocks-container__nVPCP","blocks-grid":"styles_blocks-grid__IOjGY","new-block":"styles_new-block__HIeuK"};